module.exports = __webpack_public_path__ + "img/hr-straight-rail-vertical-ties.81fcbb51.png";